// src/components/auth/AdminRoute.jsx
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { Navigate } from 'react-router-dom';
import RolesEnum from '../../common/RolesEnum'; // Asegúrate de que esta ruta sea correcta y que RolesEnum.Admin tenga el valor correcto (e.g., 2)

const AdminRoute = ({ children }) => {
  // Usamos 'user' y 'isLoading' directamente del AuthContext
  const { user, loggedIn, isLoading } = useContext(AuthContext);

  if (isLoading) {
    // Muestra un indicador de carga mientras se verifica el estado de autenticación
    return <p>Cargando...</p>;
  }

  if (!loggedIn) {
    // Si no está logueado, redirige a la página de login
    return <Navigate to="/login" replace />;
  }

  // Obtenemos los roles del usuario. Si user o user.roles es undefined, usamos un array vacío.
  const userRoles = user?.roles || [];

  // Verificamos si el usuario NO tiene el rol de Administrador.
  // Si NO incluye el rol de Admin (asumiendo que RolesEnum.Admin es el ID 2), entonces redirige a /unauthorized.
  if (!userRoles.includes(RolesEnum.Admin)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Si está logueado y tiene el rol de Administrador, renderiza los componentes hijos
  return children;
};

export default AdminRoute;